import { Space, Table } from "antd";

import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function TaskDataTable(props: any) {
  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "name",
      title: "Name",
    },
    {
      dataIndex: "username",
      title: "username",
    },
    {
      dataIndex: "password",
      title: "password",
    },
    {
      dataIndex: "companyName",
      title: "companyName",
    },
    {
      dataIndex: "address",
      title: "address",
    },
    {
      dataIndex: "client_phone",
      title: "client_phone",
    },

    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/Client/viewclient/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={props?.dataSource}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
          pageSizeOptions: ["2", "10", "20", "50"],
        }}
      />
    </div>
  );
}

export default TaskDataTable;
